module.exports = __webpack_public_path__ + "img/catstagram-details5.94da4385.png";